/// <amd-module name="SuiteCommerce.Blog.ExtCarousel.GestureInterpreter"/>
define("SuiteCommerce.Blog.ExtCarousel.GestureInterpreter", ["require", "exports", "SuiteCommerce.Blog.ExtCarousel.DOMHandler", "underscore"], function (require, exports, ExtCarousel_DOMHandler_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DOMEvents;
    (function (DOMEvents) {
        DOMEvents["touchStart"] = "touchstart";
        DOMEvents["touchMove"] = "touchmove";
        DOMEvents["touchEnd"] = "touchend";
        DOMEvents["mouseUp"] = "mouseup";
        DOMEvents["mouseMove"] = "mousemove";
        DOMEvents["mouseDown"] = "mousedown";
        DOMEvents["mouseLeave"] = "mouseleave";
    })(DOMEvents || (DOMEvents = {}));
    var ExtCarouselGestureInterpreter = /** @class */ (function () {
        function ExtCarouselGestureInterpreter(options) {
            this.startingDragThreshold = 15;
            this.$target = options.targetArea;
            this.startPosition = 0;
            this.endPosition = 0;
            this.isTouchSupported = 'ontouchstart' in window || !!navigator.maxTouchPoints;
            this.dragStartCallback = options.dragStartCallback.bind(options.context);
            this.dragEndCallback = _.throttle(options.dragEndCallback.bind(options.context), 200);
        }
        ExtCarouselGestureInterpreter.prototype.handleGestures = function () {
            if (this.isTouchSupported) {
                this.registerListenersForTouchEvents();
            }
            this.registerListenersForMouseEvents();
        };
        ExtCarouselGestureInterpreter.prototype.registerListenersForTouchEvents = function () {
            var _this = this;
            this.$target.on(DOMEvents.touchStart, function (event) {
                _this.startMovementHandler(event);
            });
            this.$target.on(DOMEvents.touchMove, function (event) {
                _this.moveHandler(event);
            });
            this.$target.on(DOMEvents.touchEnd, function (event) {
                _this.endMovementHandler(event);
            });
        };
        ExtCarouselGestureInterpreter.prototype.registerListenersForMouseEvents = function () {
            var _this = this;
            this.$target.on(DOMEvents.mouseDown, function (event) {
                _this.startMovementHandler(event);
            });
            this.$target.on(DOMEvents.mouseMove, function (event) {
                _this.moveHandler(event);
            });
            this.$target.on(DOMEvents.mouseUp + " " + DOMEvents.mouseLeave, function (event) {
                _this.endMovementHandler(event);
            });
        };
        ExtCarouselGestureInterpreter.prototype.startMovementHandler = function (event) {
            // event.changedTouches[0].clientX : touch gestures
            // event.pageX : mouse gestures
            this.startPosition = event.touches ? event.touches[0].clientX : event.pageX;
            if (this.endPosition)
                this.endPosition = 0;
        };
        ExtCarouselGestureInterpreter.prototype.moveHandler = function (event) {
            if (event.touches && event.touches.length > 1) {
                this.endPosition = 0;
            }
            else {
                this.endPosition = event.touches ?
                    event.touches[0].clientX - this.startPosition :
                    event.pageX - this.startPosition;
                if (this.startPosition !== 0 && Math.abs(this.endPosition) > this.startingDragThreshold) {
                    var absEndPosition = Math.abs(this.endPosition);
                    var directionFactor = absEndPosition / this.endPosition;
                    if (directionFactor > 0) {
                        this.dragStartCallback(this.endPosition, ExtCarousel_DOMHandler_1.Direction.left);
                    }
                    if (directionFactor < 0) {
                        this.dragStartCallback(this.endPosition, ExtCarousel_DOMHandler_1.Direction.right);
                    }
                }
            }
        };
        ExtCarouselGestureInterpreter.prototype.endMovementHandler = function (event) {
            if (this.startPosition !== 0) {
                var absEndPosition = Math.abs(this.endPosition);
                if (absEndPosition > this.startingDragThreshold) {
                    var directionFactor = absEndPosition / this.endPosition;
                    if (directionFactor > 0) {
                        this.dragEndCallback(this.endPosition, ExtCarousel_DOMHandler_1.Direction.left);
                    }
                    if (directionFactor < 0) {
                        this.dragEndCallback(this.endPosition, ExtCarousel_DOMHandler_1.Direction.right);
                    }
                }
                this.startPosition = 0;
            }
        };
        return ExtCarouselGestureInterpreter;
    }());
    exports.ExtCarouselGestureInterpreter = ExtCarouselGestureInterpreter;
});
